var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[_c('el-switch',{model:{value:(_vm.data.singlecarrier.products.deja.enabled),callback:function ($$v) {_vm.$set(_vm.data.singlecarrier.products.deja, "enabled", $$v)},expression:"data.singlecarrier.products.deja.enabled"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }